import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const profileSlice = createSlice({
  name: "profile",
  initialState: initialState,
  reducers: {
    getProfile(state, payload) {
      state.myProfile = payload.payload.response;
    },
    getUserBio(state, payload) {
      state.userBio = payload.payload.response;
    },
    alert(state, action) {
      state.error = action.payload;
    },
  },
});

export default profileSlice.reducer;
export const profileActions = profileSlice.actions;
